/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import store from '@/common/store/';
import Cookies from "js-cookie";
import { setAgentCode } from '@/common/utils/initRegisterAgentCode.js'
import { scrollToTop } from '@/common/utils/index.js'

const files = require.context('./module/', true, /\.js$/)
const modules = []
files.keys().forEach(key => {
  if (files(key).default) {
    if (files(key).default.constructor === Object) modules.push(files(key).default)
    if (files(key).default.constructor === Array) modules.push(...files(key).default)
  }
})
Vue.use(Router);

const _import = name => {
  return resolve => require([`../views/${name}`], resolve)
}

// export default
const router = new Router({  
  mode: 'history',
  base:'/',
  routes: [{
      path: '',
      component: () => import('../views/main/'),
      children: [
        {
          path: '',
          redirect: '/home'
        },
        {
          path: '/home',
          meta: {
            navShow: true,
          },
          name: 'Home',
          component: () => import('../views/home/index.vue')
        },
        {
          path: '/game/:id',
          meta: {
            navShow: true,
            gameNav: true
          },
          name: 'Game',
          component: _import('game')
        },
        // {
        //   path: '/game-list',
        //   meta: {
        //     navShow: true
        //   },
        //   name: 'GameList',
        //   component: _import('game/list')
        // },
        {
          path: '/game-sports',
          meta: {
            navShow: true
          },
          name: 'GameSports',
          component: _import('game/sports')
        },
        // {
        //   path: 'game-collect',
        //   meta: {
        //     navShow: false,
        //     titleHide: true,
        //     requireAuth: true
        //   },
        //   name: 'GameCollect',
        //   component: _import('game/collect')
        // },
        // 优惠
        {
          path: '/discounts',
          meta: {
            navShow: false,
            titleHide: true,
          },
          name: 'discounts',
          component: () => import('../views/discounts/')
        },
        {
          path: '/discounts/discountsDetail',
          meta: {
            navShow: false,
            titleHide: true
          },
          name: 'discountsDetail',
          component: () => import('../views/discounts/discountsDetail/')
        },
        { // 任务
          path: '/task',
          meta: {
            navShow: false,
            titleHide: true,
            // requireAuth:true
            requireAuth:false
          },
          name: 'Task',
          component: () => import('../views/task/')
        },
        {
          path: '/register',
          meta: {
            navShow: false,
            titleHide: true
          },
          name: 'register',
          component: () => import('../views/register/')
        },
        {
          path: '/newregister',
          meta: {
            navShow: false,
            titleHide: true
          },
          name: 'newRegister',
          component: () => import('../views/newregister/')
        },
        {
          path: '/login',
          meta: {
            navShow: false,
            titleHide: true
          },
          name: 'login',
          component: () => import('../views/login/')
        },
        // 找回密码
        {
          path: '/forgetPassword',
          meta: {
            navShow: false,
            titleHide: true
          },
          name: 'forgetPassword',
          component: () => import('../views/forgetPassword/forgetPassword')
        },
        {
          path: '/findPassword',
          meta: {
            navShow: false,
            titleHide: true
          },
          name: 'findPassword',
          component: () => import('../views/forgetPassword/findPassword')
        },
        //签到
        {
          path: '/sign',
          meta: {
            navShow: false,
            titleHide: true,
            requireAuth:true
          },
          name: 'sign',
          component: () => import('../views/sign/sign')
        }, //签到主页
        {
          path: '/integral',
          meta: {
            navShow: false,
            titleHide: true,
            requireAuth:true
          },
          name: 'integral',
          component: () => import('../views/sign/integral')
        }, //积分记录
        {
          path: '/exchange',
          meta: {
            navShow: false,
            titleHide: true,
            requireAuth:true
          },
          name: 'exchange',
          component: () => import('../views/sign/exchange')
        }, //兑换记录
        {
          path: '/rule',
          meta: {
            navShow: false,
            titleHide: true,
            requireAuth:true
          },
          name: 'rule',
          component: () => import('../views/sign/rule')
        }, //规则

        //转盘主页app跳转
        {
          path: '/wheel',
          meta: {
            navShow: false,
            titleHide: false
          },
          name: 'wheel',
          component: () => import('@/common/components/wheel/')
        },

        // 新加路由
        ...modules
      ]
    },

    // 404
    {
      path: '/404',
      meta: {
        navShow: false,
        titleHide: true
      },
      name: 'notfound',
      component: () => import('@/common/notfound/404')
    },
    {
      path: '*',
      meta: {
        navShow: false,
        titleHide: true
      },
      redirect: '/404'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      }
    }

  }
});

router.beforeEach(function(to, from, next) {
  //监听LiveChatWidget 状态
  window.LiveChatWidget ? window.LiveChatWidget.call('hide') : ''
  window.LiveChatWidget.on("visibility_changed", function(data) {
    // console.log(data)
    if (data.visibility === "minimized") {
      setTimeout(() =>{
        window.LiveChatWidget.call('hide')
      },330)
    }
  });
  // 首次进入首页跳转到棋牌
  if(window.location.host === '11ic3.com' || window.location.host === '11ic4.com'){
      let OpenFirst = Cookies.get("OpenFirst")
      if(!OpenFirst && to.name === 'Match') next('/game/2')
      next()
  }
  setAgentCode(store) // Cookies
  if (to.query.isApp) {
    store.commit('setIsApp', true)
    to.meta.navShow = false;
    to.meta.titleHide = true
  } else {
    store.commit('setIsApp', false)
  }
  store.commit('updateLoadingStatus', { isLoading: true })
  if (to.matched.some(r => r.meta.requireAuth)) {
    if (Cookies.get("UUID")) {
      next();
    } else {
      if (to.query.UUID) {
        Cookies.set("UUID", to.query.UUID)
        next()
      } else {
        // const pathArr = ['/home', '/discounts', '/Service', '/My'] // 未登录无需跳转的路由
        // if (!pathArr.includes(from.path)) next({ path: '/' })
        store.commit('updateLoadingStatus', { isLoading: false })
        if (from.path === '/register' || from.path === '/login') { // 如果未登录从注册登录页面返回 则必须登录的页面重定向直接进入首页
          next('/')
        } else {
          next('/login?backPath=' + from.fullPath + '&successPath=' + to.fullPath)
        }
      }
    }
  } else {
    if ((from.path !== '/register' && to.fullPath === '/login') || (from.path !== '/login' && to.fullPath === '/register')) {
      if(from.path == '/newregister'){
        next()
      }else{
        next(to.path + '?backPath=' + from.fullPath + '&successPath=' + from.fullPath)
      }
    } else {
      next()
    }
  }
})

var routerTime2 = null
router.afterEach((to) => {
  //进入后OpenFirst 设置位true保存一天
  if(window.location.host === '11ic3.com' || window.location.host === '11ic4.com'){
    let OpenFirst = Cookies.get("OpenFirst")
    if(!OpenFirst) Cookies.set("OpenFirst", true , { expires: 1 })
  }
  scrollToTop() // 跳转后滚动到顶部
  clearTimeout(routerTime2)
  let onloadTime = setInterval(() => {
    // document.getElementById('appRouter').style.display = 'none'
    // document.readyState判断当前节点加载状态
    // loading开始加载 interactive文件已经装载完毕，可以访问dom complete页面加载完成
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      store.commit('updateLoadingStatus', { isLoading: false });
      clearTimeout(onloadTime);
    }
  }, 400);

  routerTime2 = setTimeout(() => {
    store.commit('updateLoadingStatus', { isLoading: false })
    if (to.meta.isRefreshAccount || to.path === '/match/-2') store.dispatch('refreshAccount', { isHand: false, type: 2 }) // 是否提取并更新余额
    clearTimeout(routerTime2)
    clearTimeout(onloadTime);
  }, 3000)
  livechat.reset(to.path)
});

var LS = window.localStorage
LS.removeItem('LiveChatWidgetCount')
var livechat = {
  path: [],
  // path: [],
  timer: null,
  reset: function(links) { // 显示隐藏livechat
    clearTimeout(this.timer)
    if (!window.LiveChatWidget) {
      const count = LS.getItem('LiveChatWidgetCount') * 1
      if (count < 2) {
        LS.setItem('LiveChatWidgetCount', count + 1)
        this.reset(links)
      }
    } else {
      LS.removeItem('LiveChatWidgetCount')
      if (this.path.includes(links)) {
        window.LiveChatWidget.call('minimize')
      } else {
        window.LiveChatWidget.call('hide')
        this.timer = setTimeout(() => {
          window.LiveChatWidget.call('hide')
          clearTimeout(this.timer)
        },2500)
      }
    }
  }
}

export default router;



// WEBPACK FOOTER //
// ./src/pages/build902/router/index.js